import React, { useEffect, useState } from "react";
import { Box, Checkbox, FormControlLabel, Typography } from "@mui/material";
import moment from "moment";

const CustomProductionDateSelector = (props) => {
  const {
    allProductionDates,
    selectedProductionDates,
    setSelectedProductionDates,
    setUnselectedProductionDates,
  } = props;

  const [selectAll, setSelectAll] = useState(true);

  useEffect(() => {
    if (selectAll) {
      setSelectedProductionDates(allProductionDates);
    }
  }, [selectAll]);

  const handleSelectAllChange = (e) => {
    const checked = e.target.checked;
    setSelectAll(checked);
    setSelectedProductionDates(checked ? allProductionDates : []);
  };

  const handleDateChange = (date) => {
    const updated = selectedProductionDates.includes(date)
      ? selectedProductionDates.filter((d) => d !== date)
      : [...selectedProductionDates, date];
    // Derive unselected dates from all - selected
    const updatedUnselected = allProductionDates.filter(
      (d) => !updated.includes(d)
    );
    setUnselectedProductionDates(updatedUnselected);
    setSelectedProductionDates(updated);
    setSelectAll(updated.length === allProductionDates.length);
  };

  return (
    <Box>
      <Typography variant="subtitle1" fontWeight={600}>
        Select Dates:
      </Typography>

      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          alignItems: "center",
        }}
      >
        <FormControlLabel
          control={
            <Checkbox
              checked={selectAll}
              onChange={handleSelectAllChange}
              color="primary"
            />
          }
          label="Select All"
        />
      </Box>

      {allProductionDates?.map((date, index) => (
        <FormControlLabel
          key={index}
          control={
            <Checkbox
              checked={selectedProductionDates?.includes(date)}
              onChange={() => handleDateChange(date)}
              color="primary"
            />
          }
          label={date ? moment(date, "YYYY-MM-DD").format("DD MMM YYYY") : null}
        />
      ))}
    </Box>
  );
};

export default CustomProductionDateSelector;
